const LOGGED_OUT = 'logged_out'
const LOGIN_SUCCESSFUL = 'login_successful'
const AVATAR_IMG_UPDATED = 'avatar_img_updated'
const SHOPPING_CART_UPDATED = 'shopping_cart_updated'

export {
  LOGGED_OUT,
  LOGIN_SUCCESSFUL,
  AVATAR_IMG_UPDATED,
  SHOPPING_CART_UPDATED
}



// WEBPACK FOOTER //
// ./src/events/index.js